import { env } from '@/utils/env';

/** 拼接种草素材完整图片地址 */
export function getSeedingMediaUrl(path?: string): string {
  if (!path) return '';
  if (path.startsWith('http') || path.startsWith('//')) return path;
  return path.startsWith('/')
    ? `${env.NEXT_PUBLIC_S3_URL}${path}`
    : `${env.NEXT_PUBLIC_S3_URL}/${path}`;
}

/** 取商品主图（优先 image.product 首图） */
export function getSeedingProductImageUrl(image?: { product?: string[] }): string {
  const first = image?.product?.[0];
  if (!first) return '';
  return getSeedingMediaUrl(first);
}
